import axios from 'axios';

// ======================== Configuration ========================
const BASE_URL = 'https://loyalty.bom.asia';

// ======================== Loading Screen QLT Functions ========================

/**
 * Lấy tất cả Loading Screen QLT Images
 */
export const fetchLoadingScreenQLT = async () => {
  try {
    const response = await axios.get(`${BASE_URL}/api/imageQLT/imageLoadingSceen`);
    return response.data.images || [];
  } catch (error) {
    console.error('Error fetching loading screen:', error);
    throw error.response?.data || { message: 'Failed to fetch loading screen' };
  }
};

/**
 * Upload Loading Screen QLT Image
 */
export const fetchUploadImageScreenQLT = async (file, time) => {
  try {
    const formData = new FormData();
    formData.append('url', file);
    formData.append('time', time);

    const response = await axios.post(`${BASE_URL}/api/imageQLT/imageLoadingSceen`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data.image;
  } catch (error) {
    console.error('Error uploading image:', error);
    throw error.response?.data || { message: 'Failed to upload image' };
  }
};

/**
 * Sửa Loading Screen QLT Image
 */
export const fetchEditImageScreenQLT = async (id, formData) => {
  try {
    const response = await axios.put(`${BASE_URL}/api/imageQLT/imageLoadingSceen/${id}`, formData);
    return response.data.image;
  } catch (error) {
    console.error('Error editing image:', error);
    throw error.response?.data || { message: 'Failed to edit image' };
  }
};

/**
 * Xóa Loading Screen QLT Image
 */
export const fetchDeleteImageScreenQLT = async (id) => {
  try {
    const response = await axios.delete(`${BASE_URL}/api/imageQLT/imageLoadingSceen/${id}`);
    return { id, ...response.data };
  } catch (error) {
    console.error('Error deleting image:', error);
    throw error.response?.data || { message: 'Failed to delete image' };
  }
};

// ======================== Default Export ========================
export default {
  fetchLoadingScreenQLT,
  fetchUploadImageScreenQLT,
  fetchEditImageScreenQLT,
  fetchDeleteImageScreenQLT,
};

